<div class="map-authoring-parent">
    <emap-authoring-header></emap-authoring-header>
    <emap-authoring-toolbox></emap-authoring-toolbox>
    <emap-authoring-legend></emap-authoring-legend>
    <emap-authoring-chart></emap-authoring-chart>
    <emap-authoring-onr></emap-authoring-onr>
    <emap-map-image></emap-map-image>
</div>
